<div class="steps__header-nav">
  <div class="header-nav__item" *ngFor="let step of steps" [class.header-nav__item-active]="step.active">
    <div class="item-container">
      <a
        class="item-container__title link"
        [ngClass]="{
          'link--dotted-blue-dark': step.active,
          'link--dotted-gray-dark': !step.active
        }"
        (click)="selectStep(step)"
        >{{ step.title }}</a
      >
      <div class="item-container__description" [innerHTML]="step.description"></div>
    </div>
  </div>
</div>
<ng-content></ng-content>
<div class="steps__footer-nav">
  <ng-content select="steps-errors"></ng-content>
  <div class="footer-nav__block">
    <div class="footer-nav__item">
      <button type="button" class="button" *ngIf="!steps.last.active" (click)="nextStep()" id="appNextStep">Перейти к следующему шагу</button>
      <button type="button" class="button" *ngIf="steps.last.active" (click)="onSaveCallback($event)" id="appSaveStepsSubmit">Сохранить</button>
    </div>
    <div class="footer-nav__item">
      <a class="link link--dotted-gray-dark" (click)="onResetSteps()" id="appResetSteps">Выйти без сохранения</a>
    </div>
  </div>
</div>
